export default "__VITE_ASSET__CNoBeCni__"